<template>
    <div id="addLinkman">
      <a-form layout="vertical" :form="linkmanForm">
        <a-row>
          <a-col :span="8">
            <a-form-item class="required" :label="$t('linkman.modal.nameCN')">
              <pt-input  v-decorator="['name',{rules: [
                {required: true,message: $t('linkman.modal.nameCNTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('linkman.modal.nameCNTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="15" :offset="1">
            <a-form-item class="required" :label="$t('linkman.modal.company')">
              <pt-select
                :disabled="linkmanId != null"
                v-decorator="['businessId',{rules: [
                {required: true,message: $t('linkman.modal.companyTip'),},
                ],}]"
                showSearch
                :placeholder="$t('linkman.modal.companyTip')"
                :defaultActiveFirstOption="false"
                :showArrow="false"
                :filterOption="false"
                @search="handleSearch"
                @change="changeOwner"
                :notFoundContent="$t('linkman.modal.notData')"
              >
                <a-select-option v-for="d in companyList" :key="d.id" :value="d.id">{{d.companyName}}</a-select-option>
              </pt-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item class="required" :label="$t('linkman.modal.job')">
              <pt-input v-decorator="['job',{rules: [
                {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('linkman.modal.jobTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item class="required" :label="$t('linkman.modal.mobilePhone')">
              <pt-input v-decorator="['phone',{rules: [
                {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'}
                ],}]" :placeholder="$t('linkman.modal.mobilePhoneTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item :label="$t('linkman.modal.nameEN')">
              <pt-input v-decorator="['nameEN',{rules: [
                {min: 2, max: 128, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('linkman.modal.nameENTip')"></pt-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('linkman.modal.telephone')">
              <pt-input v-decorator="['seatNumber']" :placeholder="$t('linkman.modal.telephoneTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item :label="$t('linkman.modal.email')">
              <pt-input v-decorator="['email',{rules: [
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('linkman.modal.emailTip')"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item :label="$t('linkman.modal.dockingMan')">
              <pt-user-select :allow-clear="false"  v-decorator="['dockingPartners']" style="width: 100%;" :placeholder="$t('linkman.modal.dockingManTip')"></pt-user-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('linkman.modal.contactAddress')">
              <pt-input  v-decorator="['address',{rules: [
                {min: 2, max: 256, message: $t('linkman.modal.textMaxLength'), trigger: 'blur'},
                ],}]":placeholder="$t('linkman.modal.contactAddressTip')"></pt-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="modeType == 3">
          <a-col :span="24">
            <a-form-item  :label="$t('linkman.modal.manageProject')">
              <a-select v-decorator="['mansionIds',{rules: [

                  ],}]"  mode="multiple" :maxTagCount="1">
                <a-select-option v-for="(mansion,index) in mansionList":key="index" :value="mansion.id">{{mansion.name}}</a-select-option>
              </a-select>
              <!--<pt-select :placeholder="$t('linkman.modal.manageProjectTip')">
              </pt-select>-->
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('linkman.modal.remarks')">
              <pt-input  v-decorator="['remarks',{rules: [
                {min: 2, max: 512, message: $t('linkman.modal.textAreaLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('linkman.modal.remarksTip')" type="textarea" :autosize="{minRows:3,maxRows:3}"></pt-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {insert,update,selectOne} from '@/api/database/linkman'
  import {queryByName} from '@/api/database/linkmanChangeRecords'
  import {listAll} from '@/api/mine/account'
  import ownerMansionApi from '@/api/database/ownerMansion'
  export default {
    name: 'addLinkman',
    props:{
      modeType:{
        type:Number,
        default:1, //1新增客户联系人 2新增同行联系人 3新增业主联系人
      },
      linkmanId:null
    },
    data(){
      return{
        linkmanForm: this.$form.createForm(this,{}),
        mansionIds:[],//楼宇id
        companyList:[],//公司列表
        accountList:[],//人员列表
        linkmanVO:{},//联系人详情
        linkmanId:null,//联系人id
        mansionList:[],
        selectModel:{
          visable:false,
          loading:false
        },
      }
    },
    beforeCreate () {
      this.linkmanForm = this.$form.createForm(this)
    },
    computed:{
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    mounted(){
      this.init()
    },
    methods:{
      init(){
        this.initAccount();
        if(this.linkmanId){
          this.queryDetail();
        }
      },
      queryDetail(){
        let this_ = this
        selectOne(this_.linkmanId).then(res=>{
          if(res.code == 1){
            let temp = JSON.stringify(res.data)
            this_.linkmanVO = JSON.parse(temp.replace(/\"~\"/g,null))
            this_.fillForm();
          }
        })
      },
      fillForm(){
        if(this.linkmanVO.dockingPartners == '0'){
          this.linkmanVO.dockingPartners = undefined;
        }
        if(this.linkmanVO.linkmanMansionDOList){
          var mansionIds = [];
          this.linkmanVO.linkmanMansionDOList.forEach(mansion=>{
            var mansion = {
              id:mansion.mansionId,
              name:mansion.mansionName
            }
            mansionIds.push(mansion.id);
            this.mansionList.push(mansion);
          })
          this.linkmanVO["mansionIds"] = mansionIds;
        }
        this.companyList = [];
        var company = {
          companyName:this.linkmanVO.companyName,
          id:this.linkmanVO.businessId
        }
        this.companyList.push(company);
        setTimeout(()=>{
          this.linkmanForm.setFieldsValue(this.linkmanVO);
        },0)
      },
      changeOwner(value){
        if(this.modeType == 3){
          this.mansionListByOwnerId(value); //根据业主信息查询项目信息
        }
      },
      mansionListByOwnerId(ownerId){
        let this_ = this;
        ownerMansionApi.selectMansionProjectByOwnerId(ownerId).then(res=>{
          if(res.code == 1){
            this_.mansionList = res.data
          }
        })
      },
      initAccount(){
        let this_ = this
        listAll().then(res=>{
          this_.accountList = res.data
          //设置默认名称
          this_.linkmanForm.setFieldsValue({
            dockingPartners: this_.userInfo.accountDO.loginName
          })
          console.log(this.userInfo)
        })
      },
      handleSearch(companyName){
        setTimeout(()=>{
          let this_ = this
          if(companyName != null && companyName != ''){
            queryByName(companyName,this.modeType).then(res => {
              this_.companyList = res.data
            })
          }else{
            this_.companyList = [];
          }
        },300);
      },
      submit(){
        this.linkmanForm.validateFieldsAndScroll({force:true},(err, values) => {
          if (!err) {
            this.fillData(values);
          }else{
            this.$emit("error");
          }
        });
      },
      fillData(data){
        data["type"] =  this.modeType;
        this.companyList.forEach(company=>{
          if(data.businessId == company.id){
            data["companyName"] = company.companyName;
          }
        })
        if(data.mansionIds){
          var linkmanMansionDOList = [];
          data.mansionIds.forEach(id=>{
            var linkmanMansionDO = {
              mansionId:id
            }
            linkmanMansionDOList.push(linkmanMansionDO);
          })
          data["linkmanMansionDOList"] = linkmanMansionDOList;
        }
        if(this.linkmanId){
          data["id"] = this.linkmanVO.id;
          data["version"] = this.linkmanVO.version;
        }
        if(this.linkmanId){
          this.update(data);
        }else{
          this.save(data);
        }
      },
      save(data){
        insert(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('linkman.modal.saveSuccessTip'));
            let targetObj = {
              id: res.data.id,
              name: res.data.name,
              phone: res.data.phone,
              companyName: res.data.companyName,
            }
            this.$emit("saveSuccess",targetObj);
          }
        })
      },
      update(data){
        update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('linkman.modal.updateSuccessTip'));
            this.$emit("saveSuccess");
          }
        })
      }

    }
  }
</script>

<style scoped lang="less">
  #addLinkman{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 20px;
    .addProjectBtn{
      position: absolute;
      right: 0px;
      top:30px;
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
  }
</style>